import React from 'react';

export function createDynamicComponent<TProps extends object = object>(
  component: React.ComponentType | string,
  props: TProps
) {
  return React.createElement(component, props);
}
